'use client'

import { ReactNode, useEffect } from 'react'
import { useAppLocale } from '@/hooks'
import { setCurrentUserLocale } from '@/lib/axios'
import { LOCALE_COOKIE_NAME } from '@/constants'

type PropsType = {
  children: ReactNode
}

const LocaleProvider = ({ children }: PropsType) => {
  const { locale, backendLocale } = useAppLocale()

  useEffect(() => {
    // Set the locale for axios instance (backend format)
    setCurrentUserLocale(backendLocale)

    // Save locale to cookie for not-found and error pages (lowercase for URL consistency)
    document.cookie = `${LOCALE_COOKIE_NAME}=${locale}; path=/; max-age=31536000; SameSite=Lax`
  }, [locale, backendLocale])

  return <>{children}</>
}

export default LocaleProvider
